module.exports = __webpack_public_path__ + "img/countbg2.6144fd5a.png";